import React from "react";
import { ChevronRight, Building2, FolderKanban, Users2 } from "lucide-react";

const OrgBreadcrumb = ({ organization, workspace, group, onNavigate }) => {
    return (
        <div className="px-6 py-3 border-b dark:border-slate-800 border-slate-200 bg-white dark:bg-slate-900/50">
            <nav className="flex items-center gap-2 text-sm">
                <button
                    onClick={() => onNavigate("organization")}
                    className="flex items-center gap-2 px-3 py-1.5 rounded-lg dark:text-slate-300 text-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                >
                    <Building2 className="w-4 h-4 text-teal-500" />
                    <span className="font-medium">{organization?.name || "Organization"}</span>
                </button>

                {workspace && (
                    <>
                        <ChevronRight className="w-4 h-4 dark:text-slate-600 text-slate-400" />
                        <button
                            onClick={() => onNavigate("workspace")}
                            className={`flex items-center gap-2 px-3 py-1.5 rounded-lg transition-colors ${
                                group
                                    ? "dark:text-slate-300 text-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800"
                                    : "dark:text-white text-slate-900 bg-teal-500/10 dark:bg-teal-500/20"
                            }`}
                        >
                            <FolderKanban className="w-4 h-4 text-blue-500" />
                            <span className="font-medium">{workspace.name}</span>
                        </button>
                    </>
                )}

                {group && (
                    <>
                        <ChevronRight className="w-4 h-4 dark:text-slate-600 text-slate-400" />
                        <span className="flex items-center gap-2 px-3 py-1.5 rounded-lg dark:text-white text-slate-900 bg-teal-500/10 dark:bg-teal-500/20">
                            <Users2 className="w-4 h-4 text-purple-500" />
                            <span className="font-medium">{group.name}</span>
                        </span>
                    </>
                )}
            </nav>
        </div>
    );
};

export default OrgBreadcrumb;
